module.exports = __webpack_public_path__ + "static/img/about_01.f6e69df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/h5/about_01.png
// module id = degQ
// module chunks = 34